import { Phone, Mail } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal } from "./Reveal";

export default function CtaBand({ title, text }) {
  return (
    <section
      data-testid="cta-band"
      className="border-t border-white/10 bg-coal/40 tactical-grid"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-amber"></span> Deploy Now
          </p>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-tight max-w-3xl">
            {title}
          </h2>
          <p className="mt-5 max-w-2xl text-sm sm:text-base text-gray-400 leading-relaxed">
            {text}
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href={SITE.phoneHref}
              data-testid="cta-call-btn"
              className="group flex items-center gap-3 bg-amber text-ink font-display font-bold uppercase tracking-widest text-sm px-7 py-4 hover:bg-white transition-colors duration-300"
            >
              <Phone className="w-4 h-4" />
              Call {SITE.phone}
            </a>
            <a
              href={SITE.emailHref}
              data-testid="cta-email-btn"
              className="group flex items-center gap-3 border border-white/25 text-white font-display font-bold uppercase tracking-widest text-sm px-7 py-4 hover:border-amber hover:text-amber transition-colors duration-300"
            >
              <Mail className="w-4 h-4" />
              {SITE.email}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
